import Vue   from 'vue';
import store from "@/store/store";

const ACTIONS_LEVELS = {
  access: 1,
  read:   1,
  write:  2,
};

/**
 * @param allPermissions {{[string]: string}}
 * @param permission {string}
 * @param actionLevel {1|2}
 * @param buildingId {'any'|number}
 * @return {boolean}
 */
const hasPermission = ( allPermissions, permission, actionLevel, buildingId ) => {
  if (buildingId === 'any') {
    const testRegExp = new RegExp(`^\\d+\\.${permission}$`, "g");

    for (let permissionCode in allPermissions) {
      if (!testRegExp.test(permissionCode)) continue;
      if (allPermissions[permissionCode] >= actionLevel) return true;
    }
    return false;
  }

  const permissionCode = `${buildingId}.${permission}`;
  return allPermissions[permissionCode] >= actionLevel;
};

/**
 * @param permission {(string|string[])}
 * @param action {string} - access, read, write
 * @param buildingsId {(undefined|number|'any')}
 * @param userIds {number[]}
 * @param mcsIds {number[]}
 */
const can = ( permission, action = 'access', buildingsId, userIds, mcsIds ) => {
  if (!permission) return false;

  if (Array.isArray(userIds)) {
    const userId = store.getters['appUser/id'];
    if (!userIds.includes(userId)) return false;
  }

  if (buildingsId === undefined) {
    let house = store.getters['appUser/selectedHouse'];
    if (!house) return false;
    buildingsId = house.id;

    const mcsId = house.management_companies_id;
    if (mcsId && Array.isArray(mcsIds) && !mcsIds.includes(mcsId)) return false;
  }

  const actionLevel = ACTIONS_LEVELS[action];
  if (typeof actionLevel !== 'number') return false;

  let allPermissions = store.getters['appUser/permissions'];

  if (Array.isArray(permission)) {
    return permission.some(perm => hasPermission(allPermissions, perm, actionLevel, buildingsId));
  }

  return hasPermission(allPermissions, permission, actionLevel, buildingsId);
};

Vue.prototype.$can = can;

export default can;
